<template>
  <div class="flex w-full gap-16">
    <div>
      <RevSkeleton height="40px" shape="circle" width="40px" />
    </div>
    <div class="grow space-y-12">
      <div class="flex w-full justify-between">
        <RevSkeleton height="12px" shape="rectangle" width="90px" />
        <RevSkeleton height="12px" shape="rectangle" width="32px" />
      </div>

      <div class="space-y-8">
        <RevSkeleton height="12px" shape="rectangle" width="100%" />
        <RevSkeleton height="12px" shape="rectangle" width="100%" />
        <RevSkeleton height="12px" shape="rectangle" width="234px" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RevSkeleton } from '@ds/components/Skeleton'
</script>
